import { SETUP_CHOICES } from "../lib/eam";
import ModeInfoTip from "./ModeInfoTip";

type ChoiceId = (typeof SETUP_CHOICES)[number]["id"];

interface Props {
  value: ChoiceId;
  onChange: (id: ChoiceId) => void;
  name: string;
}

export default function SetupChoiceOptions({ value, onChange, name }: Props) {
  return (
    <div className="mt-2 space-y-2 text-sm">
      {SETUP_CHOICES.map((c) => {
        const inputId = `${name}-${c.id}`;
        return (
          <div key={c.id} className="flex items-start gap-2">
            <input
              id={inputId}
              type="radio"
              name={name}
              className="mt-1"
              checked={value === c.id}
              onChange={() => onChange(c.id)}
            />
            <div>
              <div className="flex items-center gap-1.5">
                <label htmlFor={inputId} className="font-bold">
                  {c.title}
                </label>
                <ModeInfoTip id={c.id} />
              </div>
              <label htmlFor={inputId} className="block text-gray-500">
                {c.body}
              </label>
            </div>
          </div>
        );
      })}
    </div>
  );
}
